import { Box, Container, GridLegacy as Grid } from '@mui/material'; //Grid2 is now recommended and has replaced Grid. GridLegacy is the original component.
import { DataCard, DataCardBody } from 'emerald-ui/dist/DataCard';
import { gray0, gray1 } from 'emerald-ui/dist/globals/colors';
import React from 'react';
import { DataHeader } from '../DataHeader';
import { DataHeaderRow } from '../DataHeaderRow';
import { DataSubHeaderRow } from '../DataSubHeaderRow';
import { MarketingImage } from '../MarketingImage';
import { ProgressBar } from '../ProgressBar';
import { TravelHistory } from '../TravelHistory';
import { TrackingPage_Root } from './TrackingPage.styles';
import { CargoWidget } from '../CargoWidget';
import '../../types';
import { Cancelled } from '../Cancelled';

/**
 * @typedef TrackingPageProps
 * @property {TrackingPageData} data
 * @property {string | string[]} trackingNumber
 */

/** @type {React.FC<TrackingPageProps>} */
export const TrackingPage = (props) => {
    /* eslint-disable react/jsx-max-props-per-line */
    /* eslint-disable react/jsx-sort-props */

    const {
        data,
        trackingNumber,
    } = props;

    const cancelled = data.progressIndex === -1;
    const multipleCargo = data.cargo.length > 1;
    let statusContent;

    if (cancelled && multipleCargo) {
        statusContent = (
            <>
                <Cancelled text={data.travelHistory[0].status} />
                <Box pt={3} />
                <CargoWidget data={data.cargo} />;
            </>
        );
    } else if (cancelled && !multipleCargo) {
        statusContent = <Cancelled text={data.travelHistory[0].status} />;
    } else if (!cancelled && multipleCargo) {
        statusContent = <CargoWidget data={data.cargo} />;
    } else if (!cancelled && !multipleCargo) {
        statusContent = <ProgressBar currentStepIndex={data.progressIndex} steps={data.progressLabels} />;
    }

    return (
        <TrackingPage_Root>
            <Box bgcolor={gray1} borderBottom={`1px solid ${gray0}`}>
                <Container maxWidth='xl' style={{ paddingRight: 0 }}>
                    <Box
                        sx={{ display: { xs: 'none', sm:'block' } }}
                    >
                        <DataHeader
                            headerData={data.statusHeader1}
                            subHeaderData={data.statusHeader2}
                            trackingNumber={trackingNumber}
                        />
                    </Box>
                    <Box
                        sx={{ display: { xs: 'block', sm:'none' } }}
                    >
                        <DataHeader
                            trackingNumber={trackingNumber}
                        />
                        <DataHeaderRow data={data.statusHeader1} />
                        <DataSubHeaderRow data={data.statusHeader2} />
                    </Box>
                </Container>
            </Box>
            <Container maxWidth='xl'>
                <Box pt={3}>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            sm={6}
                            xs={12}
                        >
                            {statusContent}
                            <Box
                                sx={{ display: { xs: 'none', sm:'block' } }}
                            >
                                <Box pt={3} />
                                <TravelHistory data={data.travelHistory} />
                            </Box>
                        </Grid>
                        <Grid
                            item
                            sm={6}
                            xs={12}
                        >
                            {process.env.FORWARDER === 'Navegate' && (
                                <Box
                                    sx={{ display: { xs: 'none', sm:'block' } }}
                                >
                                    <MarketingImage />
                                    <Box pt={3} />
                                </Box>
                            )}
                            <DataCard headerText='References'>
                                <DataCardBody
                                    data={data.references}
                                    labelKey='type'
                                    valueKey='value'
                                />
                            </DataCard>
                            <Box pt={3} />
                            <DataCard headerText='Locations'>
                                <DataCardBody
                                    data={data.locations}
                                    labelKey='type'
                                    valueKey='value'
                                />
                            </DataCard>
                            <Box pt={3} />
                            <DataCard headerText='Dates'>
                                <DataCardBody
                                    data={data.dates}
                                    labelKey='type'
                                    valueKey='value'
                                />
                            </DataCard>
                            <Box pt={3} />
                            <Box
                                sx={{ display: { xs: 'block', sm: 'none' } }}
                            >
                                <TravelHistory data={data.travelHistory} />
                                <Box pt={3} />
                                <MarketingImage />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </TrackingPage_Root>
    );
};
